import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useEffect, useMemo, useState } from 'react';
import { TopNewsSliderContent } from '@/components/modules/pages/top/slider/TopNewsSlider/TopNewsSliderContent';
/**
 * Top News スライダー
 * @param props
 * @returns
 */
export const TopNewsSlider = (props) => {
    const { className = '', items } = props;
    // animation用に前後を構成できるように修正
    const loopItems = useMemo(() => (items.length === 2 || items.length === 3
        ? [...items, ...items]
        : items).map((item, index) => (Object.assign(Object.assign({}, item), { loopKey: `${index}_${item.id}` }))), [items]);
    const [showIndex, changeShowIndex] = useState(0);
    const prevIndex = showIndex === 0 ? loopItems.length - 1 : showIndex - 1;
    const nextIndex = showIndex === loopItems.length - 1 ? 0 : showIndex + 1;
    // 一定時間ごとにループするように
    useEffect(() => {
        let interval = null;
        // 2つ以上ある場合のみループ
        if (loopItems.length > 1) {
            interval = setInterval(() => {
                changeShowIndex((prev) => prev === loopItems.length - 1 ? 0 : prev + 1);
            }, 5000);
        }
        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [loopItems.length]);
    return (_jsx("ul", Object.assign({ className: clsx('relative h-[69px] lg:h-[28px] overflow-hidden', className) }, { children: loopItems.map((item, index) => (_jsx("li", Object.assign({ className: clsx('absolute', 'transition-[top] duration-[0.5s] ease-in-out', 'h-full', 
            // 一つ前の要素
            index === prevIndex && loopItems.length > 1 && '-top-full', 
            // 表示中の要素
            index === showIndex && 'top-0', 
            // 一つ後の要素
            index === nextIndex && loopItems.length > 1 && 'top-full', 
            // それ以外の要素
            [showIndex, prevIndex, nextIndex].includes(index) ? '' : 'hidden') }, { children: _jsx(TopNewsSliderContent, { date: item.date, hasFile: item.hasFile, linkTo: item.linkTo, title: item.title }) }), item.loopKey))) })));
};
